import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/rafaelosorio/Documents/GitHub/tech-academy-emea/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Synopsis</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Resources & Presentations</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Deliverables</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Goals</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Guidelines</AnchorLink>
    </AnchorLinks>
    <hr></hr>
    <h2>{`Synopsis`}</h2>
    <ol>
      <li parentName="ol">{`Advise the Client on the use of Event-Driven/Near Real-time `}<strong parentName="li">{`Integration Patterns, Technologies`}</strong>{` and Implementation Strategies.`}</li>
      <li parentName="ol">{`This session was designed with the recognition that `}<strong parentName="li">{`not every student will have the same level of knowledge`}</strong>{` of IBM Event Streams or event-driven architecture.`}</li>
      <li parentName="ol"><strong parentName="li">{`Beginner Journey`}</strong>{`:  Complete an end-to-end demo (A-to-Z) off the IBM Event Streams offering deployed in CP4i`}</li>
      <li parentName="ol"><strong parentName="li">{`Advanced Journey`}</strong>{`:  Develop an event-driven / near real-time inventory management MVP solution.`}</li>
      <li parentName="ol">{`Consider the content in this session to material that enables an ‘on-going learning journey’ experience.`}</li>
    </ol>
    <hr></hr>
    <h2>{`Resources & Presentations`}</h2>
    <ul>
      <li parentName="ul">
        <a href="https://ibm.box.com/s/qw5tvrijqw5gd8qjy4cxxxrml8qo7lqj" target="_blank">Session Overview Presentation</a>
      </li>
      <li parentName="ul">
        <a href="https://ibm-cloud-architecture.github.io/eda-tech-academy/" target="_blank">Lab Handout</a>
      </li>
    </ul>
    <hr></hr>
    <h2>{`Deliverables`}</h2>
    <ol>
      <li parentName="ol">{`Capture a screen shot of your final progress with this Lab. `}<a href="https://ibm.box.com/s/k4leee7bexdwlkchybt50cp198u5nt0z">{`Upload Screen Shots Here Please`}</a>{`.`}</li>
    </ol>
    <hr></hr>
    <h2>{`Goals`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Develop a deeper understand and knowledge of key event-driven use cases, event-drive architecture patterns, and near real-time integration patterns.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Develop a core understanding of the main components that make up the IBM Events Stream offering.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Develop knowledge and skills that can be used to explain how an event-driven integration approach can be used to solve a client’s IT and business goals.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Develop skills that can be used to assess a set of client requirements or PoC goals and propose an event-driven solution approach.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Develop skill that can be used to demonstrate the IBM Event Streams offering.`}</p>
      </li>
    </ul>
    <hr></hr>
    <h2>{`Guidelines`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`This session was designed with the recognition that not every student will have the same level of knowledge of IBM Event Streams or event-driven architecture.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`This session was designed with `}<strong parentName="p">{`two (2) entry points`}</strong>{` or tracks that a student can follow depending on skill level.`}</p>
        <ul parentName="li">
          <li parentName="ul"><em parentName="li">{`Beginner Journey`}</em>{`:  This Journey is an entry level starting point and offers a `}<strong parentName="li">{`Demonstration Event Stream from A to Z`}</strong>{` experience.  This option offers a well scripted demo flow that covers all key aspects of IBM Event Streams on CP4i.`}</li>
          <li parentName="ul"><em parentName="li">{`Advanced Journey`}</em>{`:  This Journey 2 is a more advanced entry point and covers a `}<strong parentName="li">{`full body of knowledge`}</strong>{` within the near real-time / event driven architecture domain.  This Journey will have four (4) labs that progressively build out an MVP prototype supporting DoU defined goals and objectives.`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Students are `}<strong parentName="p">{`free to choose`}</strong>{` their entry point for the Tech Academy lab work.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Between Journey 1 and Journey 2 there may be `}<strong parentName="p">{`more content to cover`}</strong>{` then can be completed in this 4-hour session.  With that in mind, consider using this material as an `}<strong parentName="p">{`on-going learning activity`}</strong>{` post Academy.`}</p>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      